module.exports = __webpack_public_path__ + "static/img/icon-psd_filled.9b4af13d.svg";